if (!customElements.get('product-colour-swatches')) {
  class ProductColourSwatches extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      this.dataset.loaded = 'true';
      this.loadSiblings();
    }

    /**
     * This store lists each colour of a style as its own product, linked only by a
     * shared SKU prefix (e.g. EWD208_BLK_28 / EWD208_404_28). There's no native
     * Shopify link between them, so siblings are found via the storefront's own
     * predictive search.
     */
    async loadSiblings() {
      const styleCode = this.dataset.styleCode;
      const currentHandle = this.dataset.currentHandle;

      try {
        const searchUrl = `/search/suggest.json?q=${encodeURIComponent(styleCode)}&resources[type]=product&resources[limit]=10&resources[options][fields]=variants.sku`;
        const searchRes = await fetch(searchUrl, { headers: { Accept: 'application/json' } });
        const searchData = await searchRes.json();
        const candidateHandles = (searchData.resources?.results?.products || []).map((p) => p.handle);

        if (!candidateHandles.includes(currentHandle)) {
          candidateHandles.unshift(currentHandle);
        }

        const handles = Array.from(new Set(candidateHandles));
        const products = await Promise.all(
          handles.map((handle) =>
            fetch(`/products/${handle}.js`, { headers: { Accept: 'application/json' } })
              .then((res) => (res.ok ? res.json() : null))
              .catch(() => null)
          )
        );

        const matches = products.filter((product) => {
          const sku = product?.variants?.[0]?.sku;
          return sku && sku.split('_')[0] === styleCode && product.featured_image;
        });

        if (matches.length <= 1) return;

        this.render(matches, currentHandle);
        this.hidden = false;
      } catch (error) {
        // Leave hidden - no siblings to show.
      }
    }

    render(products, currentHandle) {
      const titles = products.map((product) => product.title);
      let prefixLength = titles[0].length;
      for (let i = 1; i < titles.length; i += 1) {
        let shared = 0;
        while (shared < prefixLength && shared < titles[i].length && titles[0][shared] === titles[i][shared]) {
          shared += 1;
        }
        prefixLength = shared;
      }
      const commonPrefix = titles[0].slice(0, prefixLength);

      products.forEach((product) => {
        const colourName = product.title.slice(commonPrefix.length).trim() || product.title;

        const link = document.createElement('a');
        link.className = 'product-colour-swatches__link';
        link.href = product.url;
        if (product.handle === currentHandle) {
          link.setAttribute('aria-current', 'page');
        }

        const img = document.createElement('img');
        img.src = ProductColourSwatches.resizeImage(product.featured_image, 88);
        img.alt = '';
        img.width = 44;
        img.height = 44;
        img.loading = 'lazy';

        const label = document.createElement('span');
        label.className = 'product-colour-swatches__label';
        label.textContent = colourName;

        link.appendChild(img);
        link.appendChild(label);
        this.querySelector('.product-colour-swatches__list').appendChild(link);
      });
    }

    static resizeImage(url, width) {
      const separator = url.includes('?') ? '&' : '?';
      return `${url}${separator}width=${width}`;
    }
  }

  customElements.define('product-colour-swatches', ProductColourSwatches);
}
